import type { Cart } from '@jane/bloom/types/schemas/bloom/checkout';
import type { ProductMaxCartQuantityOptions } from '@jane/bloom/viewModels/productDetail';

interface MaxCartLimitable {
  max_cart_quantity: number;
  max_cart_quantity_each: number;
  max_cart_quantity_eighth_ounce: number;
  max_cart_quantity_gram: number;
  max_cart_quantity_half_gram: number;
  max_cart_quantity_half_ounce: number;
  max_cart_quantity_ounce: number;
  max_cart_quantity_quarter_ounce: number;
  max_cart_quantity_two_gram: number;
  product_id: number;
}

interface GetMaxCartQuantityArgs {
  cart: Cart;
  currentProduct: MaxCartLimitable;
  currentWeight: string | undefined;
  storeId?: number;
}

/**
 * @returns {number} the remaining quantity of a product you are allowed to add to the given cart
 */
export const getMaxCartQuantity = ({
  cart,
  currentProduct,
  currentWeight,
  storeId,
}: GetMaxCartQuantityArgs): number => {
  let filter = 'max_cart_quantity';
  let priceId = 'each';

  if (currentWeight) {
    priceId = currentWeight.replace(' ', '_');
    filter = `max_cart_quantity_${priceId}`;
  }

  const maxProductQty = currentProduct[filter as ProductMaxCartQuantityOptions];

  const existingCartProduct =
    cart.storeId === storeId &&
    cart.items.find(
      (item) =>
        item.productId === currentProduct.product_id && item.priceId === priceId
    );
  return existingCartProduct
    ? maxProductQty - existingCartProduct.count
    : maxProductQty;
};
